import React from 'react';
import {Tab, Tabs} from 'react-bootstrap';
import PreviewCar from './components/PreviewCar';
import '../WorkDoc.css';
import './PreviewWorkDoc.css';
import PreviewInsurer from './components/PreviewInsurer';
import PreviewOwner from './components/PreviewOwner';
import PreviewReceiver from './components/PreviewReceiver';
import PreviewDeliver from './components/PreviewDeliver';
import FontAwsome from 'react-fontawesome';
import ExternalWorkStore from '../../../stores/ExternalWorkStore';

export default class PreviewWorkDoc extends React.Component {

  state = {
    data: {},
    loading: true,
  };

  async componentDidMount() {
    const result = await ExternalWorkStore.getWorkdocPreview(
        this.props.preview_id);
    if (result.status === 'OK') {
      this.setState({data: result.preview_data, loading: false});
    }
  }

  getTabs() {
    return [
      {
        title: <div><FontAwsome name="car" />&nbsp;ข้อมูลรถยนต์</div>,
        content: <PreviewCar {...this.state.data} loading={this.state.loading} />,
      },
      {
        title: <div><FontAwsome name="bank" />&nbsp;ประกัน/ผู้ชำระเงิน</div>,
        content: <PreviewInsurer {...this.state.data} loading={this.state.loading} />,
      },
      {
        title: <div><FontAwsome name="user" />&nbsp;เจ้าของรถยนต์</div>,
        content: <PreviewOwner {...this.state.data} loading={this.state.loading} />,
      },
      {
        title: <div><FontAwsome name="check-square-o" />&nbsp;รับรถเข้าซ่อม
        </div>,
        content: <PreviewReceiver {...this.state.data} loading={this.state.loading} />,
      },
      {
        title: <div><FontAwsome name="smile-o" />&nbsp;ส่งมอบรถ</div>,
        content: <PreviewDeliver {...this.state.data} loading={this.state.loading} />,
      },
    ];
  }

  render() {
    return (
        <div>
          <Tabs defaultActiveKey={0}>
            {this.getTabs().map((tab, tab_index) => (
                <Tab key={tab_index}
                     eventKey={tab_index}
                     title={tab.title}
                >
                  {tab.content}
                </Tab>
            ))}
          </Tabs>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/view/workdoc/preview/PreviewWorkDoc.js